<template>  
  <v-dialog
    v-model="dialogNewProducto.estatus"
    width="800"
  >
    <v-card class="elevation-0">
      <v-card-title primary-title>
        <span class="text-h6 textgrey--text"><b>Nuevo artículo</b></span>
        <v-spacer></v-spacer>
        <!-- BTN ATRAS -->
        <v-btn 
          small
          class="mr-2" 
          color="blue lighten-2" 
          @click="$emit('initialize'), dialogNewProducto.estatus = false"
          dark
          icon
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>

      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="6" md="5" lg="6" xl="5">
            <v-text-field
              clearable
              label="Ingresar Código"
              v-model="codigo"
              dense
              validate-on-blur
              class="pa-0"  
              outlined hide-details 
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col  cols="12">
            <v-text-field
              v-if="existe == false"
              label="Nombre del artículo"
              v-model="nomart"
              outlined 
              hide-details 
              dense
            ></v-text-field>
          </v-col>

          <v-col  cols="12">
            <v-textarea 
              v-if="existe == false"
              v-model = "descrip"
              outlined
              dense
              label="Descripción corta"
            >
            </v-textarea>
          </v-col>

          <v-col  cols="12">
            <v-textarea 
              v-if="existe == false"
              v-model = "descripLarga"
              outlined
              dense
              label="Descripción larga"
            >
            </v-textarea>
          </v-col>
          <v-col cols="12" v-if="alerta">
            <v-alert type="error" :value="alertaInput">
              {{alerta}}
            </v-alert>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn 
          v-if="existe == false"
          small 
          dark 
          class="mr-2" 
          @click.prevent="agregar"
          color="primary"
        >
          <v-icon left small>mdi-content-save</v-icon>
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
         
    <!-- SNACK BAR -->
    <v-snackbar
      v-model="snackbar"
      :timeout="8000"
      top
      :color="color" 
      >
      {{text}}
      <v-btn
        color="white"
        text
        @click="snackbar = false"
      >
        Cerrar
      </v-btn>
    </v-snackbar>
  </v-dialog>
</template>

<script>

  export default {

    props:[
      'dialogNewProducto'
    ],

    data () {
      return {
        familias:[],
        familia: null,
        existe: true,
        subcategorias:[],
        subcategoria:null,
        categorias: [],
        categoria:null,

        snackbar: false,
        text:'',
        color:'',

        codigo:'',
        result2:'',
        nomart:'',
        sal:'',
        lab:'',

        alerta:'',
        alertaInput: false,

        descrip:'',

        descripLarga:'',

      }
    },

    created(){
      this.$http.get('familias.activo').then(response=>{
        this.familias = response.body
      }).catch(error=>{
        console.log('error',error)
      })
    },

    computed: {
      validaInfo(){
        return  this.nomart      !==  '' && 
                this.descrip     !==  '' &&       
                this.codigo      !==  '' 
      },
    },
      
    watch:{
      codigo(){
        if(this.codigo != ''){
          this.$http.get('articulos.codigo/'+ this.codigo).then(response=>{
            if(response.body.length > 0){
              this.existe = true
              this.text = 'Producto ya existente'
              this.snackbar = true
            }else{
              this.existe = false
            }
          }).catch(error=>{
            this.existe = false
            console.log('error',error)
          })
        }else{this.existe = true}
      },

      familia () {
        this.categorias = []
        if(this.familia){
          this.$http.get('categorias.familia/'+ this.familia.idfamilias).then(response=>{
            this.categorias = response.body
          }).catch(error=>{
            this.existe = false
            console.log('error',error)
          })
        }
      },

      categoria () {
        this.subcategorias = []
        if(this.categoria){
          this.$http.get('subcategorias.categoria/'+ this.categoria.idcategorias).then(response=>{
            this.subcategorias = response.body
          }).catch(error=>{
            this.existe = false
            console.log('error',error)
          })
        }
      }
    },

    methods:{

      agregar(){
        this.alerta = ''
        if(!this.validaInfo){
          if(!this.codigo){
            this.alerta = `No has asignado un codigo al articulo`
          }
          if(!this.nomart){
            this.alerta = this.alerta +`
            No has asignado un nombre al articulo`
          }
          if(!this.descrip){
            this.alerta = this.alerta +`
            No has asignado un compuesto  al articulo`
          }

          this.alertaInput = true
        }else{
          var payload = {
            nomart:           this.nomart,
            codigo:           this.codigo,
            descrip:          this.descrip,
            descripLarga:     this.descripLarga,
            idfamilias:       0,
            idcategorias:     0,
            idsubcategorias:  0,
          }

          if(this.familia){payload.idfamilias = this.familia.idfamilias}
          if(this.categoria){payload.idcategorias = this.categoria.idcategorias}
          if(this.subcategoria){payload.idsubcategorias = this.subcategoria.idsubcategorias}

          this.$http.post('articulos.add', payload).then(response=>{
            this.text  = 'Artículo agregado'
            this.snackbar = true
            setTimeout(() => (this.$router.push({name: 'catproductos'})), 1500)
          })
        }
      }
    }
  }
</script>